const parseURL = (searchOptions, router, fn = () => {}) => {
  const formattedQueryGroup = {
    CaseNames: [],
    Issues: [],
    States: [],
    Statuses: [],
    PageSize: 10,
    Page: 1,
    SortOrder: 'ASC',
    SortField: 'CASENAME',
  };
  const { query: queryGroup, asPath: url } = router;

  const hasQueryInitializer = url.indexOf('?') > -1;

  if (!hasQueryInitializer) {
    return formattedQueryGroup;
  }
  const queryKeys = Object.keys(queryGroup);

  queryKeys.forEach(k => {
    const _k = k.toLowerCase();
    switch (_k) {
      case 'cases':
        formattedQueryGroup.CaseNames = queryGroup[k].split(',').map(v => {
          return { Value: v };
        });
        fn('CaseNames', queryGroup[k].split(','));
        break;
      case 'statuses':
        formattedQueryGroup.Statuses = queryGroup[k].split(',').map(s => {
          return { StatusCode: s };
        });
        fn('Statuses', queryGroup[k].split(','));
        break;
      case 'issues':
        formattedQueryGroup.Issues = queryGroup[k].split(',').map(i => {
          return { IssueId: i };
        });
        fn('Issues', queryGroup[k].split(','));
        break;
      case 'states':
        formattedQueryGroup.States = queryGroup[k].split(',').map(s => {
          return { StateCode: s };
        });
        fn('States', queryGroup[k].split(','));
        break;
      default:
        break;
    }
  });

  return formattedQueryGroup;
};

export default parseURL;
